
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  feedback: true,
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Instantly process ACH/RTP/FedNow with TabaPay’s Unified API using your Plaid Token"
};
export const partnerProps = {
  partner: 'TabaPay',
  clientLibrary: 'taba_pay',
  subtitle: metadata.description,
  registrationUrl: 'https://developers.tabapay.com/docs/plaid',
  apiUrl: 'https://developers.tabapay.com/docs/plaid',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`TabaPay and Plaid have partnered together to offer streamlined pay-by-bank solutions to mutual customers. TabaPay is the leading money movement platform, transforming the payments landscape for Fintechs and financial institutions with secure, reliable, and low-cost instant payments. TabaPay provides direct access to 15 banking partners and 14 networks along with innovative products and features in one unified API. TabaPay processes over 1 million transactions daily on behalf of more than 2,500 clients in the U.S. and Canada. By integrating TabaPay's Unified API and Plaid Link, Fintechs and financial institutions can securely authenticate external bank accounts to push or pull funds via highly reliable, flexible, low-cost payment methods.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
